import { logout } from "../../actions/rootActions";
import { Paths } from "../../constants/UrlConstants";
import MemberHelper from "../../helpers/MemberHelper";
import MemberTelephoneService from "../../services/MemberTelephoneService";
import PersonConsentService, { isGDPRSet } from "../../services/PersonConsent";
import { GetPolicyDetails } from "../../services/PolicyDetails";
import PrintPreferenceService from "../../services/PrintPreferenceService";
import { SET_LOGGED_IN_STATE } from "../account/accountActions";
import { setUnreadMessageCount } from "./../inbox/InboxActions";
import { setNotifications } from "./../notifications/notificationsAction";
import  PreferencesService from "../../services/PreferencesService";
import HttpStatusCodes from "http-status-codes";
import {
  SystemUnavailable,
  LoginStatus,
  UserStatus
} from "../../constants/Constants";
import { RedirectToLogin } from "../../helpers/AccountsHelper";
import SystemUnavailability from "../../services/SystemUnavailabilityService";
import { redirectForInvalidPolicyValidationStatus } from "../../validations/PolicyValidation";
import userManager from "../../helpers/UserManagerHelper";
import { setOIDCUser } from "../../actions/account/accountActions";
import { redirectToErrorPageMessage } from "../../logging/CommonLogMessages";
import { trackException } from "../../logging/AppInsightsLogger";

export const SET_POLICY_DETAILS = "SET_POLICY_DETAILS";
export const SET_SELECTED_POLICY = "SET_SELECTED_POLICY";
export const SET_SELECTED_POLICY_MEMBERSHIP_NUMBER =
  "SET_SELECTED_POLICY_MEMBERSHIP_NUMBER";
export const SET_IS_COMM_VALUE_CHANGED = "SET_IS_COMM_VALUE_CHANGED";
export const SET_CAROUSEL_COUNT = "SET_CAROUSEL_COUNT";
export const SET_IS_PREF_CONFIRM = "SET_IS_PREF_CONFIRM";
export const SET_IS_COMM_VALUE = "SET_IS_COMM_VALUE";
export const SET_TOTAL_COUNT = "SET_TOTAL_COUNT";
export const SET_IS_VALUE_CHANGED = "SET_IS_VALUE_CHANGED";
export const UPDATE_CONTACT_PREFERENCES = "UPDATE_CONTACT_PREFERENCES";
export const UPDATE_FORMAT2_TELEPHONENUMBERS =
  "UPDATE_FORMAT2_TELEPHONENUMBERS";
export const UPDATE_PRINT_PREFERENCES = "UPDATE_PRINT_PREFERENCES";
export const CONTACT_PREFERENCE_INTERNAL_VIEW =
  "CONTACT_PREFERENCE_INTERNAL_VIEW";
export const SET_DEEP_LINKING_URL = "SET_DEEP_LINKING_URL";
export const SET_MEMBER_DETAIL_UPDATED = "SET_MEMBER_DETAIL_UPDATED";
export const LOAD_COMM_PREFS_KEYS = "LOAD_COMM_PREFS_KEYS";
export const LOAD_CONTACT_PREFS_KEYS = "LOAD_CONTACT_PREFS_KEYS";
export const SET_IS_ELGIBLE_CUSTOMISED = "SET_IS_ELGIBLE_CUSTOMISED";
export const LOAD_COMM_OPTION_VALUE = "LOAD_COMM_OPTION_VALUE";
export const PERSON_NOT_FOUND = "PERSON_NOT_FOUND";
export const LOAD_CONTACT_OPTION_VALUE = "LOAD_CONTACT_OPTION_VALUE";
export const LOAD_CONTACT_OPTION_VALUE_ONBOARD = "LOAD_CONTACT_OPTION_VALUE_ONBOARD";
export const SAVE_CONTACT_PREF = "SAVE_CONTACT_PREF";
export const SAVE_COMMUNICATION_PREF = "SAVE_COMMUNICATION_PREF";
export const SET_SERVICE_INVOKE_FLAG = "SET_SERVICE_INVOKE_FLAG";

export function setPolicyDetails(history) {
  return async (dispatch, getState) => {
    let { oidc, accountReducer, policyReducer, onboardingReducer } = getState()
      ? getState()
      : {};
    let deepLinkingUrl = accountReducer && accountReducer.deepLinkingUrl;

    if (oidc && !oidc.user) {
      await SystemUnavailability();
      let user = await userManager.getUser();
      if (user && !user.expired) {
        await setOIDCUser(user);
      } else {
        await RedirectToLogin(deepLinkingUrl);
        return;
      }
    } else if (oidc && oidc.user && oidc.user.expired) {
      history.replace(Paths.Timeout);
      return;
    }

    if (
      policyReducer &&
      policyReducer.policyDetails &&
      policyReducer.policyDetails.Policies
    ) {
      return;
    }

    let policyDetails = null;
    try {
      var response = await GetPolicyDetails();

      if (response.status === HttpStatusCodes.OK) {
        policyDetails = response.data;
        
        dispatch({
          type: SET_POLICY_DETAILS,
          payload: policyDetails
        });

        dispatch({
          type: SET_LOGGED_IN_STATE,
          payload: true
        });

        let selectedPolicyMembershipNumber =
          policyReducer && policyReducer.selectedPolicyMembershipNumber;

        if (
          policyDetails.HasMultiplePolicies &&
          !selectedPolicyMembershipNumber
        ) {
          history.push(Paths.ChooseYourPlan);
        } else {
          let policy = policyDetails.Policies[0];
          if (selectedPolicyMembershipNumber) {
            policy = policyDetails.Policies.find(
              (p) => p.MembershipNumber === selectedPolicyMembershipNumber
            );
          }

          let marketingPrefs = await dispatch(setSelectedPolicy(policy)); 
          let contactPrefs = await dispatch(setContactPreferences(policy));      
          let checkMasterData = await dispatch(checkConsumerDutyMasterData());
          let localcontactPrefs  = contactPrefs === undefined || contactPrefs === null ? null : contactPrefs.contactPreferences; 
          let commPrefs = localcontactPrefs === null ? null :contactPrefs.communicationPreferences;

          if (onboardingReducer && !onboardingReducer.isUserOnboarding) {
            if (isGDPRSet(marketingPrefs)) {
              if (deepLinkingUrl) {
                await dispatch(setDeepLinkingUrl(null));
                history.push(deepLinkingUrl);
              } else {
                history.push(Paths.HomeRoot);
              }
            } else {
              history.push(Paths.PersonConsent);
            }
          }
          else {
            if((localcontactPrefs === null || localcontactPrefs === undefined) && checkMasterData !=null ){
              history.push(Paths.HomeContactPreference);
            }                     
            else {
              if((commPrefs === null || commPrefs === undefined) && checkMasterData !=null ){
              history.push(Paths.HomeCommunicationPreference);
              }
            }
          }
        }
      }
    } catch (error) {
      if (error.response) {
        const errorData = error.response.data;
        const canDispatchLogout =
          errorData &&
          errorData.status !== SystemUnavailable &&
          errorData.status !== UserStatus.Reset &&
          errorData.status !== UserStatus.UserDoesNotExist;
        const isForbiddenStatus =
          error.response.status !== HttpStatusCodes.FORBIDDEN;

        LogError(
          (errorData && errorData.status) || error.response.status,
          oidc
        );
        if (isForbiddenStatus || !errorData || canDispatchLogout) {
          await dispatch(logout());

          if (
            errorData &&
            errorData.status &&
            LoginStatus.hasOwnProperty(errorData.status)
          ) {
            redirectForInvalidPolicyValidationStatus(errorData.status, history);
          } else {
            history.push(Paths.Error);
          }
        }
      }
    }
  };
}

function LogError(status, oidc) {
  let errorToLog = {
    Status: status,
    UserProfile: oidc && oidc.user && oidc.user.profile
  };
  trackException(
    redirectToErrorPageMessage,
    `Something went wrong while fetching policy details. Error: ${JSON.stringify(
      errorToLog
    )}`
  );
}

export function setTelephoneNumbers(policy, history) {
  return async (dispatch) => {
    var member = MemberHelper.getCurrentLoggedInMemberFromPolicy(policy);

    if (policy.IsFormat2 && !member.PhoneNumbers) {
      try {
        const telephones = await getMemberTelephoneNumbers(
          policy.MembershipNumber
        );

        dispatch({
          type: UPDATE_FORMAT2_TELEPHONENUMBERS,
          payload: {
            TelephoneNumbers: telephones.TelephoneNumbers,
            MembershipNumber: policy.MembershipNumber
          }
        });
      } catch (error) {
        trackException(
          redirectToErrorPageMessage,
          `Something went wrong while set telephone numbers. MembershipNumber: ${JSON.stringify(
            policy && policy.MembershipNumber
          )}`
        );
        history.push(Paths.Error);
      }
    }
  };
}

export function updatePrintPreferences(membershipNumber, documentPreference) {
  return async (dispatch) => {
    await setPrintPreferencesInApi(membershipNumber, documentPreference);

    dispatch({
      type: UPDATE_PRINT_PREFERENCES,
      payload: {
        PrintPreference: documentPreference,
        MembershipNumber: membershipNumber
      }
    });
  };
}

export function getPrintPreferences(policy, history) {
  return async (dispatch) => {
    var member = MemberHelper.getCurrentLoggedInMemberFromPolicy(policy);
    if (!member.DocumentPreference) {
      try {
        const printPreference = await getPrintPreferencesInApi(
          policy.MembershipNumber
        );
        dispatch({
          type: UPDATE_PRINT_PREFERENCES,
          payload: {
            PrintPreference: printPreference,
            MembershipNumber: policy.MembershipNumber
          }
        });
      } catch (error) {
        trackException(
          redirectToErrorPageMessage,
          `Something went wrong while fetching print preferences. MembershipNumber: ${JSON.stringify(
            policy && policy.MembershipNumber
          )}`
        );
        history.push(Paths.Error);
      }
    }
  };
}

export function contactPreferenceInternalView() {
  return {
    type: CONTACT_PREFERENCE_INTERNAL_VIEW
  };
}

export function checkConsumerDutyMasterData() {  
  return async (dispatch) => {       
    let service = new PreferencesService();
    return  await service.loadPreferencekeysService()  
      .then((data) => {
        dispatch({
          type: LOAD_CONTACT_PREFS_KEYS,
          payload: data.CustomerDutyMasterData.ContactPreferences
        });       
        return data.CustomerDutyMasterData.ContactPreferences;
      })
      .catch(() => {
        dispatch({
          type: LOAD_CONTACT_PREFS_KEYS,
          payload:  null,
        });    
        }); 
  };
}

export function setContactPreferences(policy) {  
if (policy !==null) {
  return (dispatch) => {
    let service = new PreferencesService();
    return  service.loadOptionValueService(policy.MembershipNumber)  
      .then((data) => {
        dispatch({
          type: LOAD_CONTACT_OPTION_VALUE_ONBOARD,
          payload:  data.ConsumerDutyData  ,
        });                     
        return data.ConsumerDutyData  ;
      })
      .catch(() => {
        dispatch({
          type: LOAD_CONTACT_OPTION_VALUE_ONBOARD,
          payload:  null,
        });  
        dispatch({
          type: SET_SELECTED_POLICY,
          payload: policy
        });  
        }); 
  };
} 
}

export function setCommunicationPreferences(commPrefs) {  
return (dispatch) => {
  dispatch({
    type: LOAD_COMM_OPTION_VALUE,
    payload:  commPrefs,
  });    
  dispatch({
   type: SET_SERVICE_INVOKE_FLAG,
   payload :true,
  });  
};
}

export function setSelectedPolicy(policy) {
  if (policy.PersonConsent === undefined) {
    return (dispatch) => {
      dispatchSetMessageActionsForSelectedPolicy(dispatch, policy);
      return getContactPreferences(policy.MembershipNumber)
        .then((data) => {
          dispatch({
            type: UPDATE_CONTACT_PREFERENCES,
            payload: {
              PersonConsent: data.ContactPreferences || null,
              MembershipNumber: policy.MembershipNumber
            }
          });
          dispatch({
            type: SET_SELECTED_POLICY,
            payload: policy
          });
          return data.ContactPreferences;
        })
        .catch(() => {
          dispatch({
            type: UPDATE_CONTACT_PREFERENCES,
            payload: {
              PersonConsent: null,
              MembershipNumber: policy.MembershipNumber
            }
          });
          dispatch({
            type: SET_SELECTED_POLICY,
            payload: policy
          });
          return null;
        });
    };
  }
  return (dispatch) => {
    dispatchSetMessageActionsForSelectedPolicy(dispatch, policy);
    dispatch({
      type: SET_SELECTED_POLICY,
      payload: policy
    });
    return policy.PersonConsent;
  };
}

function dispatchSetMessageActionsForSelectedPolicy(dispatch, policy) {
  dispatch(setUnreadMessageCount(policy));
  dispatch(setNotifications(policy));
}

function getContactPreferences(membershipNumber) {
  let service = new PersonConsentService();
  return service.GetPersonConsent(membershipNumber);
}

function getPrintPreferencesInApi(membershipNumber) {
  let service = new PrintPreferenceService();
  return service.GetPrintPreference(membershipNumber);
}

function setPrintPreferencesInApi(membershipNumber, documentPreference) {
  let service = new PrintPreferenceService();
  return service.SetPrintPreference(membershipNumber, documentPreference);
}

function getMemberTelephoneNumbers(membershipNumber) {
  let service = new MemberTelephoneService();
  return service.GetMemberTelephoneNumbers(membershipNumber);
}

export function updateContactPreferences(
  membershipNumber,
  personConsent,
  history,
  isRedirectionNotRequired
) {
  isRedirectionNotRequired = !!isRedirectionNotRequired;
  return (dispatch, getState) => {
    let service = new PersonConsentService();

    return service
      .SetPersonConsent({
        MembershipNumber: membershipNumber,
        ContactPreferences: personConsent
      })
      .then(() => {
        let result = dispatch({
          type: UPDATE_CONTACT_PREFERENCES,
          payload: {
            MembershipNumber: membershipNumber,
            PersonConsent: personConsent
          }
        });
        if (!isRedirectionNotRequired) { 
          history.replace(Paths.DocumentPreference);  
        }
        return result;
      });
  };
}

export function setDeepLinkingUrl(url) {
  return (dispatch) => {
    return dispatch({
      type: SET_DEEP_LINKING_URL,
      payload: url
    });
  };
}

export function setSelectedPolicyMembershipNumber(membershipNumber) {
  return {
    type: SET_SELECTED_POLICY_MEMBERSHIP_NUMBER,
    payload: membershipNumber
  };
}

export function setIsValueChanged(Value){
  return{
    type: SET_IS_VALUE_CHANGED,
    payload: Value
  };
}

export function setvalueCofirm(Value){
  return {
    type :SET_IS_PREF_CONFIRM,
    payload:Value
  };
}

export function setCommValue(Value){
  return {
    type: SET_IS_COMM_VALUE,
    payload: Value
  };
}

export function setIsCommValueChanged(Value)
{
  return {
    type: SET_IS_COMM_VALUE_CHANGED,
    payload: Value
  };
}


export function setCarouselCount(Count) {
    return {
      type: SET_CAROUSEL_COUNT,
      payload: Count
    };
  }

  export function setTotalCount(Count) {
    return {
      type: SET_TOTAL_COUNT,
      payload: Count
    };
  }
export function loadPreferencekeys() {
  return async (dispatch) => {
    let service = new PreferencesService();
    var response = await service.loadPreferencekeysService();
    try{
      dispatch({
        type: LOAD_CONTACT_PREFS_KEYS,
        payload: response.CustomerDutyMasterData.ContactPreferences
      });
      dispatch({
        type: LOAD_COMM_PREFS_KEYS,
        payload: response.CustomerDutyMasterData.CommunicationPreferences,
        
      });
     
      dispatch({
        type: SET_IS_ELGIBLE_CUSTOMISED,
        payload: response.isElgibleCustomised
      });
    }
    catch(e)
    {
      dispatch({
        type: LOAD_CONTACT_PREFS_KEYS,
        payload: null
      });
      dispatch({
        type: LOAD_COMM_PREFS_KEYS,
        payload: null
      });
      dispatch({
        type: SET_IS_ELGIBLE_CUSTOMISED,
        payload: null
      });
    } 
 };
}

export function loadOptionValues(membershipNumber) {
  return async (dispatch) => {
    let service = new PreferencesService();
    var response = await service.loadOptionValueService(membershipNumber);
    try{
      if(response !== null)
      {
     dispatch({
        type: LOAD_CONTACT_OPTION_VALUE,
        payload: response.ConsumerDutyData.contactPreferences
      });
      dispatch({
        type: LOAD_COMM_OPTION_VALUE,
        payload: response.ConsumerDutyData.communicationPreferences
      });
    }
    else{
      dispatch({
        type: PERSON_NOT_FOUND,
        payload: true
      });
    }
  }
  catch(e){
    dispatch({
      type: LOAD_CONTACT_OPTION_VALUE,
      payload: undefined
    });
    dispatch({
      type: LOAD_COMM_OPTION_VALUE,
      payload: undefined
    });
    dispatch({
      type: PERSON_NOT_FOUND,
      payload: false
    });
  }
  };
}

export function saveContactPreferences(
  membershipNumber,
  ContactPreferences){
    return async (dispatch) => {
      let service = new PreferencesService();
      var response = await service.saveContactPreferenceService({membershipNumber,ContactPreferences});
      try{
       dispatch({
          type: SAVE_CONTACT_PREF,
          payload: response.ContactPreference
        });
    }
    catch(e){
      dispatch({
        type: SAVE_CONTACT_PREF,
        payload: null
      });
    }
    }; 
  }

  export function saveCommunicationPreferences(
    membershipNumber,
    CommunicationPreferences){
      return async (dispatch) => {
        let service = new PreferencesService();
        var response = await service.saveCommunicationPreferenceService({membershipNumber,CommunicationPreferences});
        try{
         dispatch({
            type: SAVE_COMMUNICATION_PREF,
            payload: response.CommunicationPreference
          });
      }
      catch(e){
        dispatch({
          type: SAVE_COMMUNICATION_PREF,
          payload: null
        });
      }
      }; 
    }
